import React, { useState } from "react";

const faqData = [
  {
    question: "How quickly can you repair my TV?",
    answer: "Most common issues like backlight problems, power issues, and software glitches are fixed within the same day. For screen replacements or parts that need ordering, it typically takes 24-48 hours. We always keep you updated on the timeline.",
  },
  {
    question: "Do you provide home visit service for TV and washing machine repair?",
    answer: "Yes! We provide doorstep repair service across Pune and Pimpri-Chinchwad for both TVs and washing machines. Our technician will come to your home, diagnose the issue, and repair it on-site whenever possible. No need to carry heavy appliances anywhere.",
  },
  {
    question: "What TV brands do you repair?",
    answer: "We repair all major brands including Samsung, LG, Sony, Mi (Xiaomi), OnePlus, TCL, Vu, Panasonic, Philips, Toshiba, and more. Whether it's a budget TV or a premium model, our technicians have the expertise.",
  },
  {
    question: "Do you repair washing machines?",
    answer: "Yes! We offer complete washing machine repair and service for all major brands including Whirlpool, Samsung, LG, Bosch, IFB, Godrej, and Haier. We handle drum issues, water leakage, motor problems, spin cycle faults, and more — for both front-load and top-load models.",
  },
  {
    question: "Is there a diagnosis/inspection fee?",
    answer: "We offer free basic diagnosis at our service center. For home visits, a nominal inspection fee applies which is adjusted against the repair cost if you proceed with the repair. No hidden charges — ever.",
  },
  {
    question: "Do you provide warranty on repairs?",
    answer: "Yes, all our repairs — both TV and washing machine — come with a service warranty. The warranty period varies depending on the type of repair — typically 30 to 90 days. Screen replacements come with up to 6 months warranty.",
  },
  {
    question: "How do I book a repair service?",
    answer: "It's super easy! Just click the 'Book Repair Now' button or WhatsApp us at 8007113950. Share your TV or washing machine issue and we'll schedule a visit at your convenience. You can also call us directly for immediate assistance.",
  },
  {
    question: "What areas in Pune do you serve?",
    answer: "We serve all of Pune including Pimpri-Chinchwad, Wakad, Hinjewadi, Baner, Aundh, Kothrud, Hadapsar, Viman Nagar, Kharadi, Dighi, Charholi, and surrounding areas. Contact us to check if your area is covered.",
  },
  {
    question: "What washing machine problems can you fix?",
    answer: "We fix all common washing machine problems including: not turning on, water leakage, drum not spinning, excessive vibration, water not draining, error codes, door/lid issues, motor problems, and timer/control panel faults. Both front-load and top-load washing machines of all brands.",
  },
];

const ChevronIcon = () => (
  <svg className="faq-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq-section" className="section section-alt" aria-label="Frequently asked questions">
      <div className="section-inner">
        <div className="section-header">
          <div className="section-label">FAQ</div>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Got questions about TV or washing machine repair? We've got answers. If you don't find what you're looking for, WhatsApp us anytime.
          </p>
        </div>

        <div className="faq-list">
          {faqData.map((faq, index) => (
            <div key={index} className={`faq-item ${openIndex === index ? "open" : ""}`}>
              <button className="faq-question" onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index}>
                <span>{faq.question}</span>
                <ChevronIcon />
              </button>
              <div className="faq-answer">
                <div className="faq-answer-inner">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
